import { requst } from '../config'

/* 用户列表分页 */
export const getUserListPaginatedDataApi = params => {
    let query = ''
    Object.keys(params).forEach(item => (query += `&${item}=${params[item]}`))
    const url = `/setting/project/user/userListByProjectOwnerCompany?` + query.slice(1)
    return requst.get(url)
}

/* 批量新增项目人员 */
export const postProjectUsersApi = params => {
    const url = '/setting/project/user/addBatch'
    return requst.post(url, params)
}

/* 删除项目人员 */
export const deleteProjectUsersApi = id => {
    const url = `/setting/project/user/${id}`
    return requst.delete(url)
}

/* 获取项目人员 */
export const getProjectUserListApi = projectId => {
    const url = `/setting/project/user/getProjectUsers/${projectId}`
    return requst.get(url)
}

/* 导入其它项目人员 */
export const getProjectExportUserListApi = (sourceProjectId, targetProjectId) => {
    const url = `/setting/project/user/importProjectUser?sourceProjectId=${sourceProjectId}&targetProjectId=${targetProjectId}`
    return requst.get(url)
}

/* 获取 location 列表 */
export const getLocationListApi = projectId => {
    const url = `/setting/location/list?projectId=${projectId}`
    return requst.get(url)
}

/* 获取 location 权限列表 */
export const getLocationAuthListApi = locationId => {
    const url = `/setting/location/treeAll/${locationId}`
    return requst.get(url)
}

/* 获取 项目 权限列表 */
export const getProjectAuthListApi = type => {
    const url = `/setting/project/menu/treeAll?type=${type}`
    return requst.get(url)
}

/* 获取角色列表1以及对应默认权限 */
export const getRoleListApi = () => {
    const url = `/system/role/listDetail?type=preinstall`
    return requst.get(url)
}

/* 获取角色列表2 */
export const getRoleList2Api = () => {
    const url = `/system/role/listDetail?type=user`
    return requst.get(url)
}

// /* 修改项目人员角色 */
// export const putProjectUserRoleApi = params => {
//     const url = `/setting/project/user/updateUserRole`
//     return requst.put(url, params)
// }

/* 获取项目人员权限 */
export const getProjectUserAuthApi = userId => {
    const url = `/setting/project/user/getUserAuth/${userId}`
    return requst.get(url)
}

/* 修改项目人员权限 */
export const postProjectUserAuthApi = params => {
    const url = 'setting/project/user/updateUserAuth'
    return requst.post(url, params)
}
